import type { ICobranzaRepository, GetUnitsParams, PaginatedResponse } from '@yawi/domain';
import { buildQueryString } from '@yawi/domain';
import type { UnitCobranza, CobranzaSummary, AutoBlockConfig } from '@yawi/types';
import { getApiClient } from '../../http/apiClient';
import { fetchAllPages } from '../../utils/fetchAllPages';

export class ApiCobranzaRepository implements ICobranzaRepository {
  async getSummary(): Promise<CobranzaSummary> {
    const client = getApiClient();
    return client.get<CobranzaSummary>('v1/cobranza/summary');
  }

  async getUnits(params: GetUnitsParams): Promise<UnitCobranza[]> {
    const client = getApiClient();
    // La tabla muestra el conjunto completo: antes solo llegaban las primeras 100 unidades.
    const units = await fetchAllPages((page) =>
      client.get<PaginatedResponse<UnitCobranza>>(
        `v1/cobranza/units?${buildQueryString({
          filter: params.filter,
          sort: params.sort,
          search: params.query || undefined,
          ...page,
        })}`,
      ),
    );
    return units.map((u) => ({
      ...u,
      lastPaymentDate: u.lastPaymentDate ?? '',
      residents: u.residents ?? [],
    }));
  }

  async updateAccess(unitId: string, isBlocked: boolean): Promise<void> {
    const client = getApiClient();
    await client.patch(`v1/cobranza/units/${unitId}/access`, { isBlocked });
  }

  async bulkUpdateAccess(unitIds: string[], isBlocked: boolean): Promise<{ updated: number }> {
    const client = getApiClient();
    return client.patch<{ updated: number }>('v1/cobranza/units/bulk-access', {
      ids: unitIds,
      isBlocked,
    });
  }

  async getAutoBlockConfig(): Promise<AutoBlockConfig> {
    const client = getApiClient();
    return client.get<AutoBlockConfig>('v1/cobranza/auto-block-config');
  }

  async saveAutoBlockConfig(config: AutoBlockConfig): Promise<void> {
    const client = getApiClient();
    await client.put('v1/cobranza/auto-block-config', config);
  }
}
